/**
 * Discord 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <DiscordIcon className="w-8 h-8" />
 * <DiscordIcon className="w-12 h-12" />
 * ```
 */
export function DiscordIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Discord icon"
      role="img"
    >
      <title>Discord</title>
      <g id="Discord">
        <path
          id="Vector"
          d="M25.7187 6.8425C23.9062 5.98175 21.9682 5.3562 19.942 5C19.6932 5.45663 19.4025 6.07081 19.2021 6.55939C17.0482 6.23062 14.9142 6.23062 12.8 6.55939C12.5996 6.07081 12.3023 5.45663 12.0513 5C10.0229 5.3562 8.08272 5.98405 6.27023 6.84705C2.61442 12.4544 1.62339 17.9224 2.1189 23.3128C4.54363 25.1507 6.89348 26.2672 9.20367 26.9977C9.77407 26.2009 10.2828 25.3539 10.721 24.4612C9.88638 24.1393 9.08695 23.742 8.33159 23.2808C8.53198 23.1302 8.728 22.9726 8.91738 22.8105C13.5246 24.9977 18.5304 24.9977 23.0825 22.8105C23.2741 22.9726 23.4701 23.1302 23.6683 23.2808C22.9107 23.7443 22.1091 24.1416 21.2745 24.4635C21.7127 25.3539 22.2192 26.2032 22.7918 27C25.1042 26.2694 27.4563 25.153 29.881 23.3128C30.4624 17.064 28.8878 11.6461 25.7187 6.8425ZM11.3487 19.9977C9.96568 19.9977 8.83148 18.6872 8.83148 17.0913C8.83148 15.4955 9.94146 14.1827 11.3487 14.1827C12.756 14.1827 13.8902 15.4932 13.8659 17.0913C13.8681 18.6872 12.756 19.9977 11.3487 19.9977ZM20.6512 19.9977C19.2682 19.9977 18.134 18.6872 18.134 17.0913C18.134 15.4955 19.2439 14.1827 20.6512 14.1827C22.0584 14.1827 23.1926 15.4932 23.1684 17.0913C23.1684 18.6872 22.0584 19.9977 20.6512 19.9977Z"
          fill="#5865F2"
        />
      </g>
    </svg>
  );
}
